import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./HomeHeader.module.css";
import logo from "../../assets/images/logo_1.png";
import { useAuth } from "../../hooks/useAuth";
import { TokenService } from "../../services/Api";

const HomeHeader = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    // { label: "Status", path: "/status" },
    { label: "Home", path: "/" },
    { label: "Why iFillip", path: "/why-ifillip" },
    { label: "Explore More", path: "/explore-more" },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleRequestDemo = () => {
    navigate("/request-demo");
  };

  const handleLogin = async () => {
    const user = TokenService.getUser();

    if (user) {
      try {
        await logout();
      } catch (error) {
        console.error("Logout error:", error);
      } finally {
        TokenService.clearAll();
        window.location.href = "/login";
      }
    } else {
      window.location.href = "/login";
    }
  };

  // const handleLogin = async () => {
  //   const user = TokenService.getUser();
  //   console.log("111");

  //   if (user) {
  //         console.log("3333");
  //     try {
  //       await logout();
  //       navigate("/login", { replace: true });
  //     } catch (error) {
  //       console.error("Logout error:", error);
  //       navigate("/login", { replace: true });
  //     } finally {
  //       navigate("/login", { replace: true });
  //     }
  //   } else {
  //         console.log("222");
  //     navigate("/login");
  //   }
  // };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logoSection}>
          <Link to="/" className={styles.logoLink}>
            <img src={logo} alt="iFillip Logo" className={styles.logo} />
          </Link>
        </div>

        <button
          className={styles.mobileMenuToggle}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span
            className={`${styles.hamburger} ${
              isMobileMenuOpen ? styles.active : ""
            }`}
          >
              <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <nav
          className={`${styles.nav} ${
            isMobileMenuOpen ? styles.mobileNavOpen : ""
          }`}
        >
          <ul className={styles.navList}>
            {navItems.map((item, index) => (
              <li key={index} className={styles.navItem}>
                <Link
                  to={item.path}
                  className={styles.navLink}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div
          className={`${styles.actionButtons} ${
            isMobileMenuOpen ? styles.mobileActionsOpen : ""
          }`}
        >
          <button className={styles.requestDemoBtn} onClick={handleRequestDemo}>
            Request Demo
          </button>
          <button className={styles.loginBtn} onClick={handleLogin}>
            Login
          </button>
        </div>
      </div>
    </header>
  );
};

export default HomeHeader;
